<template>
  <v-container>
    <v-card max-width="500">
      <v-list>
        <v-subheader>Vinnie beheer</v-subheader>
        <v-list-item :to="{ name: 'BeheerOverzicht' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-credit-card-outline </v-icon>
          </v-list-item-icon>
          <v-list-item-content
            >Overzicht tokens en consoles</v-list-item-content
          >
        </v-list-item>
        <v-list-item :to="{ name: 'users' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-outline </v-icon>
          </v-list-item-icon>
          <v-list-item-content>Beheer medewerkers</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "beheer",
  components: {},
};
</script>
